
export default {
  name: 'BaseProfileAuthorRecommendationsItem',
  props: {
    recommendation: {
      type: Object,
      default: null,
    },
  },
  computed: {
    preText() {
      if (this.recommendation?.text) {
        const text = this.recommendation.text
        if (text?.blocks?.length) {
          let preText = text.blocks?.filter(
            (block) => block.type === 'paragraph' || block.type === 'header'
          )
          preText = preText.slice(0, 2).map((p) => {
            return p.data.text
          })

          preText = preText.join('<br />')
          const sanitizeText = preText.replace(/&nbsp;/g, ' ').trim()
          return sanitizeText
        }
      }
      return ''
    },
  },
  methods: {
    inView({ isInView }) {
      if (isInView) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/recommendation', {
        username: this.recommendation.author.username,
        recommendationId: this.recommendation._id,
      })
    },
    openPreviewModal() {
      this.$refs.previewModal.open(this.recommendation._id)
    },
  },
}
